import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "layout-page" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "flex-grow-1 container-p-y px-4" }
const _hoisted_4 = { class: "d-flex justify-content-between aling-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold py-3 mb-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-light" }, "Cutomer"),
    /*#__PURE__*/_createTextVNode(" Form ")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Back to List")
const _hoisted_7 = { class: "" }
const _hoisted_8 = {
  key: 0,
  class: "alert alert-success alert-dismissible",
  role: "alert"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Successfully ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "aria-label": "Close"
}, null, -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-12 col-sm-12" }
const _hoisted_14 = { class: "card" }
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-company"
}, "Name ", -1)
const _hoisted_19 = { class: "col-sm-12" }
const _hoisted_20 = { class: "row mb-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-company"
}, "Phone ", -1)
const _hoisted_22 = { class: "col-sm-12" }
const _hoisted_23 = { class: "row mb-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-company"
}, "National Indentity Number ", -1)
const _hoisted_25 = { class: "col-sm-12" }
const _hoisted_26 = { class: "row mb-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-company"
}, "Date of Birth ", -1)
const _hoisted_28 = { class: "col-sm-12" }
const _hoisted_29 = { class: "row mb-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-sm-12 col-form-label",
  for: "basic-icon-default-company"
}, "Address ", -1)
const _hoisted_31 = { class: "col-sm-12" }
const _hoisted_32 = { class: "col-md-12 col-sm-12" }
const _hoisted_33 = { class: "row justify-content-end" }
const _hoisted_34 = { class: "col-sm-12" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 1,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_38 = {
  key: 2,
  class: "visually-show"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "content-backdrop fade" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBarView = _resolveComponent("TopBarView")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopBarView),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, {
                  to: "/customer",
                  class: "btn btn-primary mt-2"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.successReport)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
                : _createCommentVNode("", true),
              _createElementVNode("form", {
                name: "",
                onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _hoisted_18,
                            _createElementVNode("div", _hoisted_19, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "basic-icon-default-fullname",
                                placeholder: "Name",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                                required: ""
                              }, null, 512), [
                                [_vModelText, _ctx.formData.name]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("div", _hoisted_22, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "basic-icon-default-fullname",
                                placeholder: "Phone",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.phone) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.formData.phone]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _hoisted_24,
                            _createElementVNode("div", _hoisted_25, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "basic-icon-default-fullname",
                                placeholder: "NID No",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.nid_no) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.formData.nid_no]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("div", _hoisted_28, [
                              _withDirectives(_createElementVNode("input", {
                                type: "Date",
                                class: "form-control",
                                id: "basic-icon-default-fullname",
                                placeholder: "Date of Birth",
                                onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.formatDate && _ctx.formatDate(...args))),
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.date_of_birth) = $event))
                              }, null, 544), [
                                [_vModelText, _ctx.formData.date_of_birth]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _hoisted_30,
                            _createElementVNode("div", _hoisted_31, [
                              _withDirectives(_createElementVNode("textarea", {
                                class: "form-control",
                                id: "exampleFormControlTextarea1",
                                rows: "5",
                                placeholder: "Address",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.address) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.formData.address]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: "btn btn-primary mt-3",
                          disabled: _ctx.submitBtn
                        }, [
                          (!_ctx.submitBtn)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Save"))
                            : _createCommentVNode("", true),
                          (_ctx.submitBtn)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_37))
                            : _createCommentVNode("", true),
                          (_ctx.submitBtn)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_38, " Saving..."))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_35)
                      ])
                    ])
                  ])
                ])
              ], 32)
            ])
          ])
        ])
      ]),
      _createVNode(_component_Footer),
      _hoisted_39
    ])
  ]))
}